<template>
  <div class="edt">
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">{{ pageTitle }}
          </h1>
        </v-toolbar-title>
      </div>
      <v-spacer />
      <div>
        <v-btn
          color="primary"
          class="mr-4"
          medium
          @click="onCancel"
          :disabled="form.$busy"
          text
          style="text-transform: none;"
        >Cancel</v-btn>
        <v-btn
          color="primary"
          medium
          @click="onSave"
          :loading="form.$busy"
          style="text-transform: none;"
        >Save</v-btn>
      </div>
    </v-app-bar>
    <v-row class="px-4 py-4">
      <v-col
        lg="8"
        md="6"
        sm="12"
        xs="12"
      >
        <v-card
          outlined
          class="px-6 py-8"
        >
          <v-select
            v-model="form.version"
            :items="bannerTypes"
            :error-messages="replace(head(form.$getError('version')), 'version', 'Banner Type')"
            outlined
          />

          <v-text-field
            v-model="form.banner_name"
            outlined
            label="Banner Name"
            :error-messages="form.$getError('banner_name')"
          />

          <image-file-input-viewer
            label="Banner Logo"
            v-model="form.thumbnail"
            :error-messages="replace(head(form.$getError('thumbnail')), 'The thumbnail field', 'Banner logo')"
          />

          <image-file-input-viewer
            label="Mobile Banner Logo"
            v-model="form.thumbnail_mobile"
            :error-messages="replace(head(form.$getError('thumbnail_mobile')), 'The thumbnail mobile field', 'Mobile Banner logo')"
          />

          <image-file-input-viewer
            v-if="form.version === 'product_banner'"
            label="Header icon"
            v-model="form.product_thumbnail"
            :error-messages="replace(head(form.$getError('product_thumbnail')), 'The product thumbnail field', 'Header icon')"
          />

          <normal-content-editor
            v-model="form.title"
            editorHeight="200"
            label="Header text"
            :errorMessages="replace(head(form.$getError('title')), 'The title field', 'Header text')"
          />

          <normal-content-editor
            class="mt-8"
            v-model="form.mobile_title"
            editorHeight="200"
            label="Mobile Header text"
            :errorMessages="replace(head(form.$getError('mobile_title')), 'The mobile title field', 'Mobile Header text')"
          />

          <!-- <v-text-field
            v-model="form.title"
            outlined
            label="Title"
            :error-messages="form.$getError('title')"
          /> -->

          <!-- <v-text-field
            v-model="form.font_size"
            outlined
            label="Font Size"
            type="number"
            :error-messages="form.$getError('font_size')"
          ></v-text-field>

          <v-select
            v-model="form.txt_weight"
            outlined
            label="Text Weight"
            :error-messages="form.$getError('txt_weight')"
            :items="txtWeightOptions"
          /> -->

          <v-textarea
            class="mt-5"
            outlined
            label="Fallback URL"
            v-model="form.callback_url"
            rows="2"
            :error-messages="form.$getError('callback_url')"
          />

          <v-text-field
            v-model="form.btn_text"
            outlined
            label="Button Text"
            :error-messages="form.$getError('btn_text')"
          />

          <v-text-field
            v-model="form.btn_height"
            outlined
            label="Button Height(px)"
            :error-messages="form.$getError('btn_height')"
            type="number"
          />

          <color-picker
            label="Button Color"
            v-bind:color.sync="form.btn_color"
            :error-messages="form.$getError('btn_color')"
          />

          <color-picker
            label="Button Text Color"
            v-bind:color.sync="form.btn_text_color"
            :error-messages="form.$getError('btn_text_color')"
          />

          <!-- <color-picker
            label="Button Hover Color"
            v-bind:color.sync="form.btn_hover"
            :error-messages="form.$getError('btn_hover')"
          /> -->

          <affiliates-input
            v-if="form.version === 'conversion_banner'"
            :errorMessages="form.$getErrors()"
            inputName="Target State URLs"
            v-bind:items.sync="form.affiliate_links"
          />
        </v-card>
      </v-col>
      <v-col
        lg="4"
        md="6"
        sm="12"
      >
        <slug-generator
          ref="slugGenerator"
          :base-string="form.banner_name"
          v-model="slug"
          :error-messages="form.$getError('slug')"
        />

        <bookmaker-code v-bind:bookmakerCode.sync="form.bookmaker_code" />

        <v-text-field
          class="mt-4"
          v-model="form.review_text"
          outlined
          label="Review Text"
          :error-messages="form.$getError('review_text')"
        />

        <v-text-field
          v-model="form.review_url"
          outlined
          label="Review URL"
          :error-messages="form.$getError('review_url')"
        />
        <v-switch
          v-model="form.review_is_new_tab"
          label="Open review link on new tab"
        />

        <v-switch
          v-model="form.is_new_tab"
          label="Open callback URLs on new tab"
        />

        <checklist-input
          v-bind:items.sync="form.checklists"
          :errorMessages="head(form.$getError('checklists'))"
        />

        <image-alt-text v-bind:imageAltText.sync="form.image_alt_text" />

      </v-col>
    </v-row>
    <v-overlay
      absolute
      :value="updating"
    >
      <v-dialog
        v-model="updating"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
  </div>
</template>

<script>
import Form from '@/utils/form'
import get from 'lodash/get'
import head from 'lodash/head'
import replace from 'lodash/replace'
import InContentConversionBanner from '@/models/InContentConversionBanner'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import { mapActions } from 'vuex'
import ColorPicker from '@/components/ColorPicker'
import ImageFileInputViewer from '@/components/ImageFileInputViewer'
import ImageAltText from '@/components/ImageAltText'
import AffiliatesInput from './AffiliatesInput.vue'
import map from 'lodash/map'
import ChecklistInput from './ChecklistInput.vue'
import NormalContentEditor from '@/components/NormalContentEditor'
import SlugGenerator from '@/components/SlugGenerator'
import slugify from 'slugify'
import forEach from 'lodash/forEach'
import BookmakerCode from '@/components/BookmakerCode'


const initialData = {
  title: null,
  callback_url: null,
  btn_color: '#000000',
  btn_hover: '#000000',
  btn_text: null,
  version: 'conversion_banner',
  affiliate_links: [],
  thumbnail: null,
  image_alt_text: null,
  checklists: [],
  thumbnail_mobile: null,
  btn_text_color: null,
  review_text: null,
  review_url: null,
  is_new_tab: true,
  banner_name: null,
  slug: null,
  product_thumbnail: null,
  review_is_new_tab: true,
  btn_height: null,
  mobile_title: null,
  bookmaker_code: null
}

export default {
  data () {
    return {
      loading: false,
      updating: false,
      loading_message: 'Loading',
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      loadingTags: false,
      form: new Form({
        ...initialData
      }),
      txtWeightOptions: [
        '300',
        '400',
        '500',
        '600'
      ],
      bannerTypes: [
        {
          text: 'Product Banner',
          value: 'product_banner'
        },
        {
          text: 'SportsBook Banner',
          value: 'conversion_banner'
        }
      ]
    }
  },
  props: {
    inContentConversionBanner: {
      type: [InContentConversionBanner, Object],
      default () {
        return {}
      }
    },
    pageTitle: {
      type: String,
      default: 'In-Content Conversion Banners'
    },
    redirectCancelTo: {
      type: [String, Object],
      default () {
        return {
          name: 'in-content-banners'
        }
      }
    },
    redirectSaveTo: {
      type: [String, Object],
      default () {
        return {
          name: 'in-content-banners'
        }
      }
    }
  },

  components: {
    AppBarNavIcon,
    ColorPicker,
    ImageFileInputViewer,
    ImageAltText,
    AffiliatesInput,
    ChecklistInput,
    NormalContentEditor,
    SlugGenerator,
    BookmakerCode
  },

  methods: {
    head,
    replace,
    ...mapActions({
      updateRecord: 'InContentConversionBanner/update'
    }),

    onCancel () {
      this.$router.replace(this.redirectCancelTo)
    },

    async onSave () {
      try {
        this.form.$busy = true
        this.form.$clearErrors()
        const data = this.form.$data()

        data.slug = data.slug ? data.slug : this.slug

        if (data.version === 'product_banner') { this.$delete(data, 'affiliate_links') }

        if (this.isModeUpdate) {
          data._method = 'put'

          if (data.thumbnail && data.thumbnail.id) { this.$delete(data, 'thumbnail') }
          if (data.thumbnail_mobile && data.thumbnail_mobile.id) { this.$delete(data, 'thumbnail_mobile') }
          if (data.product_thumbnail && data.product_thumbnail.id) { this.$delete(data, 'product_thumbnail') }
        }

        const inContentConversionBanner = new InContentConversionBanner(data)
        await inContentConversionBanner.save()

        this.$router.replace(this.redirectSaveTo)
      } catch (error) {
        if (get(error, 'response.status') === 422) {
          if (get(error, 'response.data.errors') !== null) {
            this.form.$setErrors(get(error, 'response.data.errors'))
          } else {
            this.showSnackbar('Something went wrong.', 'error')
          }
        } else {
          this.showSnackbar(error, 'error')
        }
      } finally {
        this.form.$busy = false
      }
    },
    showSnackbar (message, color = 'success') {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }

  },

  watch: {
    inContentConversionBanner: {
      immediate: true,
      handler (val) {
        if (val) {
          this.form = new Form({
            ...initialData,
            ...val
          })

          if (val.thumbnail) {
            this.form.image_alt_text = val.thumbnail.custom_properties.alt_text
          }

          if (val.affiliate_links) {
            forEach(val.affiliate_links, (value, key) => {
              if (value && value.states) {
                this.form.affiliate_links[key].us_states_ids = map(get(value, 'states'), item => {
                  return item.id

                })
              }
            })

          }

          if (!this.form.slug) {
            this.$nextTick(() => this.$refs['slugGenerator'].generate())
          }
        }
      }
    }
  },

  computed: {
    isModeUpdate () {
      return get(this.form, 'id', null) !== null
    },

    slug: {
      get () {
        if (this.form.slug && this.form.slug.trim() !== '') {
          return this.form.slug
        }

        if (this.form.banner_name) {
          return slugify(this.form.banner_name, {
            remove: /[*+~.()'"!:@]/g,
            lower: true,
            strict: true
          })
        }

        return null
      },
      set (v) {
        this.form.slug = v
      }
    },
  },

  created () {
    if (!this.isModeUpdate) {
      this.form.affiliate_links = []
      this.form.checklists = []
    }

  }
}
</script>
